import type { IContextMutationResult } from '@modules/core/services/query/types';
import type { IEmployeeEditPayload, IEmployeeEditResponse } from '@modules/employees/submodules/edit/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { EMPLOYEES_LIST_PERMISSIONS, EMPLOYEES_LIST_QUERY_KEY } from '@modules/employees/constants';
import { EMPLOYEE_EDIT_API_URL, EMPLOYEE_EDIT_MUTATION_KEY } from '@modules/employees/submodules/edit/constants';
import { useToastStore } from '@modules/toast/store';

export default function useEmployeeEditMutation(): IContextMutationResult<
  IEmployeeEditResponse,
  Error,
  IEmployeeEditPayload
> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<IEmployeeEditResponse, Error, IEmployeeEditPayload>({
    mutationKey: [EMPLOYEE_EDIT_MUTATION_KEY],
    mutationFn: ({ id, ...payload }) => fetchPut<IEmployeeEditResponse>(
      EMPLOYEE_EDIT_API_URL,
      payload,
      {
        permission: EMPLOYEES_LIST_PERMISSIONS.EDIT,
        urlParams: {
          id,
        },
      },
    ),
    onSuccess({ queryClient }) {
      void queryClient.invalidateQueries({ queryKey: [EMPLOYEES_LIST_QUERY_KEY] });
      displayPresetToast('edited');
    },
  });
}
